import { MasterServiceDtoType } from 'config/apiFunus/generated/data-contracts';
import OrderType from 'models/OrderType';

export enum OtherTypes {
  ACCEPT_FLOWERS_REQUEST = 'ACCEPT_FLOWERS_REQUEST',
  ADD = 'ADD',
  ADD_ARTICLE_DISAGREEMENT = 'ADD_ARTICLE_DISAGREEMENT',
  AFFECTED_QUESTIONS_ALERT = 'AFFECTED_QUESTIONS_ALERT',
  ARTICLE_DRAFT_EDIT = 'ARTICLE_DRAFT_EDIT',
  ASSIGN_RECORD = 'ASSIGN_RECORD',
  BUDGET = 'BUDGET',
  BUDGET_ACCEPT = 'BUDGET_ACCEPT',
  BUDGET_BACKWARD = 'BUDGET_BACKWARD',
  BUDGET_CONFIG = 'BUDGET_CONFIG',
  BUDGET_EDIT_QUESTION = 'BUDGET_EDIT_QUESTION',
  CANCEL_FLOWERS = 'cancel-flowers',
  COPY = 'COPY',
  CUT = 'CUT',
  DELETE = 'DELETE',
  DOWNLOAD = 'DOWNLOAD',
  DUPLICATE = 'DUPLICATE',
  EDIT = 'EDIT',
  EMAIL = 'EMAIL',
  ERROR = 'ERROR',
  FILE = 'FILE',
  FLOWERS = 'FLOWERS',
  FOLDER = 'FOLDER',
  FOLDER_PLUS = 'FOLDER_PLUS',
  FORBIDEN = 'FORBIDEN',
  HOME = 'HOME',
  ICONS_VIEW ='ICONS_VIEW',
  INVOICE = 'INVOICE',
  LIST_VIEW ='LIST_VIEW',
  MOVE_BACK = 'MOVE_BACK',
  MOVE_END = 'MOVE_END',
  MOVE_NEXT = 'MOVE_NEXT',
  NO_ELEMENTS = 'no-elements',
  PASTE = 'PASTE',
  PENDANT = 'pendant',
  PHOTO = 'PHOTO',
  PRINT = 'PRINT',
  PRINT_ARTICLE_COMERCIAL = 'PRINT_ARTICLE_COMERCIAL',
  QR = 'QR',
  RELIQUARY = 'reliquary',
  RESTORE = 'RESTORE',
  SAVE = 'SAVE',
  SIGN = 'SIGN',
  VALID = 'VALID',
  VIEW = 'VIEW',
}

export enum FeatherIconTypes {
  CHECKCIRCLE = 'CHECKCIRCLE',
  CHEVRONLEFT = 'CHEVRONLEFT',
  CHEVRONRIGHT = 'CHEVRONRIGHT',
  CLOCK = 'CLOCK',
  EDIT = 'FEATHER_EDIT',
  EYE = 'EYE',
  FILEPLUS = 'FILEPLUS',
  PACKAGE = 'PACKAGE',
  SEND = 'SEND',
  SETTINGS = 'SETTINGS',
  TRASH = 'TRASH',
  TRASH2 = 'TRASH2',
  TRELLO = 'TRELLO',
  USERPLUS = 'USERPLUS',
}

export type CustomIconProps = {
  className?: string;
  icon: MasterServiceDtoType | OrderType | OtherTypes | FeatherIconTypes;
};
